import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Spin, Avatar, List, Checkbox, Badge } from "antd";
import _ from "lodash";
import { HomeOutlined, SettingOutlined } from "@ant-design/icons";





const MembersPopup: FC<{
    users: any,
    allUsers: any[],
    adminRoles: any[],
    isMembersLoading: boolean
}> = ({
    users = {},
    allUsers,
    adminRoles,
    isMembersLoading
}) => {
        const getUserObj = (userObj) => {
            const user = allUsers?.find((obj) => obj.id === userObj.id);
            const role = adminRoles?.find((x) => {
                return x._id === user?.roleId;
            });
            return {
                profileImage:
                    user?.profileImage?.urls?.original?.url ?? "/images/users/user.png",
                beamId: user?.beamId
                    ? user?.beamId
                    : userObj?.beamId && userObj?.beamId !== ""
                        ? userObj?.beamId
                        : `user #${userObj.id}`,
                role: role?.name,
                department: user?.department,
            };
        };
        const dynamicSort = (property) => {
            var sortOrder = 1;
            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                var result =
                    a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                return result * sortOrder;
            };
        };

        const userObjs = Object.keys(users).map((user) => {
            return getUserObj({ id: user });
        });
        userObjs.sort(dynamicSort("beamId"));
        return (
            <div className="edit-menu ml-auto people-dropdown group-menu-container">
                <div className="menu-item">
                    <div><h6>Members({userObjs.length})</h6></div>
                    {isMembersLoading && (<div id="loading">
                        <Spin className="mt-5" tip="Loading">
                            <div className="content" />
                        </Spin>
                    </div>)}
                    <Row style={{ height: "150px" }} className="beam-modal scroll-bar">
                        <Col span={24}>
                            {userObjs.map((user, index) => (
                                <Row key={index} className="person-item">
                                    <React.Fragment>
                                        <Col span={4}>
                                            <img src={user.profileImage} width="30" height="30" />
                                        </Col>
                                        <Col span={13}>
                                            <h5>{user.beamId}</h5>
                                            {user.role && (<Badge count={
                                                <div className="custom-badge text-white pl-2 pr-2 bg-green">
                                                    <span><SettingOutlined /></span>
                                                    <span className="ml-1" style={{ verticalAlign: "middle" }}>{user.role}</span></div>
                                            }/>)}
                                            {user.department && (<Badge className="ml-1" count={
                                                <div className="custom-badge text-white pl-2 pr-2 bg-orange">
                                                    <span><HomeOutlined /></span>
                                                    <span className="ml-1" style={{ verticalAlign: "middle" }}>{user.department}</span></div>
                                            } />)}
                                        </Col>
                                    </React.Fragment>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                </div>
            </div>
        );
    };

export default MembersPopup;
